// @ts-nocheck
import * as Types from '../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SignUpHomeownerMutationVariables = Types.Exact<{
  input: Types.SignUpHomeownerInput;
}>;


export type SignUpHomeownerMutation = { __typename?: 'Mutation', signUpHomeowner: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };


export const SignUpHomeownerDocument = gql`
    mutation SignUpHomeowner($input: SignUpHomeownerInput!) {
  signUpHomeowner(input: $input) {
    emptyResult
  }
}
    `;
export type SignUpHomeownerMutationFn = Apollo.MutationFunction<SignUpHomeownerMutation, SignUpHomeownerMutationVariables>;

/**
 * __useSignUpHomeownerMutation__
 *
 * To run a mutation, you first call `useSignUpHomeownerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpHomeownerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpHomeownerMutation, { data, loading, error }] = useSignUpHomeownerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpHomeownerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SignUpHomeownerMutation, SignUpHomeownerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SignUpHomeownerMutation, SignUpHomeownerMutationVariables>(SignUpHomeownerDocument, options);
      }
export type SignUpHomeownerMutationHookResult = ReturnType<typeof useSignUpHomeownerMutation>;
export type SignUpHomeownerMutationResult = Apollo.MutationResult<SignUpHomeownerMutation>;
export type SignUpHomeownerMutationOptions = Apollo.BaseMutationOptions<SignUpHomeownerMutation, SignUpHomeownerMutationVariables>;